import {
  Dashboard as DashboardIcon,
  ShoppingCart as OrdersIcon,
  Inventory2 as ProductsIcon,
  AccountCircle as ProfileIcon,
  ReceiptLong as PurchasesIcon,
} from '@mui/icons-material';
import { BottomNavigation, BottomNavigationAction, Paper } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { useI18n } from '../../contexts/I18nContext';

export default function AdminBottomNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useI18n();

  const value = (() => {
    const p = location.pathname;
    if (p.startsWith('/products')) return '/products';
    if (p.startsWith('/orders')) return '/orders';
    if (p.startsWith('/profile')) return '/profile';
    if (p.startsWith('/purchases')) return '/purchases';
    return '/dashboard';
  })();

  return (
    <Paper
      elevation={8}
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: (theme) => theme.zIndex.appBar + 10,
        pb: 'env(safe-area-inset-bottom)',
      }}
    >
      <BottomNavigation
        value={value}
        onChange={(_, next) => navigate(next)}
        showLabels
      >
        <BottomNavigationAction
          label={t('nav.home')}
          value="/dashboard"
          icon={<DashboardIcon />}
        />
        <BottomNavigationAction
          label={t('nav.products')}
          value="/products"
          icon={<ProductsIcon />}
        />
        <BottomNavigationAction
          label={t('nav.orders')}
          value="/orders"
          icon={<OrdersIcon />}
        />

        <BottomNavigationAction
          label={t('nav.purchases')}
          value="/purchases"
          icon={<PurchasesIcon />}
        />

        <BottomNavigationAction
          label={t('nav.myProfile')}
          value="/profile"
          icon={<ProfileIcon />}
        />
      </BottomNavigation>
    </Paper>
  );
}
